import React from "react";
import ReactTypingEffect from "react-typing-effect";

const Home = () => {
  return (
    <div>
      <h1 className="title">Rakesh Nayak.</h1>
      <ReactTypingEffect
        className="myRole"
        speed="200"
        eraseSpeed="10"
        eraseDelay="2000"
        typingDelay="10"
        text={[
          "Software Developer",
          "Web Developer",
          "Frontend Developer",
          "UI/UX",
        ]}
      />
    </div>
  );
};

export default Home;
